import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@components/common';
import { get, isEqual } from 'lodash';
import utils from '@utils';

class OfficerDetails extends Component {
	shouldComponentUpdate({ officer, timeZoneId }) {
		const lastProps = this.props;
		return (
			!isEqual(officer, lastProps.officer)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
		);
	}

	render() {
		const { officer, timeZoneId } = this.props;

		return (
			<div className="padding-top-25 padding-left-45 padding-right-45">
				<div className="flex flex-wrap">
					<div className="margin-bottom-20">
						<Image
							className="height-45 width-45 border-radius-rounded margin-right-45 img-cover"
							src={get(officer, 'ProfilePhotoUrl', '')}
							fallbackSrc="avatar"
						/>
					</div>
					<div className="flex-auto margin-bottom-20">
						<div className="flex flex-align-items-center margin-bottom-5">
							<div className="font-size-16">
								{ get(officer, 'ContactViewModel.FirstName', '') }
								{' '}
								{ get(officer, 'ContactViewModel.LastName', '') }
							</div>
							<span className="simple-text margin-left-11 margin-top-4">
								{ utils.parseUTCDateToTimeZone(get(officer, 'ContactViewModel.CreateDateUTC', Date.now()), timeZoneId).fromNow() }
							</span>
						</div>
						<div className="simple-text margin-bottom-10">
							{ `${get(officer, 'OfficerRank', '')} | ${get(officer, 'JurisdictionModel.Name', '')}` }
						</div>
						<div className="flex flex-align-items-center tags">
							<div className="tag margin-right-10">
								{ utils.abbreviateNumber(get(officer, 'OfficerStatisticsModel.CompletedJobsCount', '')) }
								{' '}
								Jobs Worked
							</div>
							<div className="tag margin-right-10">
								{ utils.abbreviateNumber(get(officer, 'OfficerStatisticsModel.UpcomingJobsCount', '')) }
								{' '}
								Upcoming Jobs
							</div>
							<div className="tag margin-right-10">
								{ utils.abbreviateNumber(get(officer, 'OfficerStatisticsModel.TotalHours', '')) }
								{' '}
								Total Hours
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

OfficerDetails.propTypes = {
	officer    : PropTypes.object,
	timeZoneId : PropTypes.string,
};

OfficerDetails.defaultProps = {
	officer    : {},
	timeZoneId : '',
};

export default OfficerDetails;
